import React from "react";
import {
  Button,
  Box,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  ButtonGroup,
  SelectChangeEvent,
} from "@mui/material";
import moment from "moment";

interface PatientData {
  name: string;
  birthDate: string;
  gender: string;
  mobile: string;
}

interface PatientModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
  patientData: PatientData;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleSelectChange: (event: SelectChangeEvent) => void;
  handleQuickBirthDate: (years: number) => void;
  title?: string;
  submitText?: string;
}

const PatientModal: React.FC<PatientModalProps> = ({
  open,
  onClose,
  onSubmit,
  patientData,
  handleInputChange,
  handleSelectChange,
  handleQuickBirthDate,
  title = "환자 등록",
  submitText = "등록",
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Box component="form" noValidate sx={{ mt: 2 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="name"
            label="이름"
            name="name"
            value={patientData.name}
            onChange={handleInputChange}
            autoFocus
          />
          <TextField
            margin="normal"
            required
            fullWidth
            id="birthDate"
            label="생년월일"
            name="birthDate"
            type="date"
            value={patientData.birthDate}
            onChange={handleInputChange}
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              inputProps: {
                max: moment().format("YYYY-MM-DD"), // 오늘 이후 날짜 선택 방지
                min: "1900-01-01", // 너무 과거 날짜 선택 방지
              },
            }}
            helperText="환자의 생년월일을 선택하세요 (1900-01-01 ~ 오늘)"
          />
          <Box mt={1} mb={2}>
            <Typography variant="caption" display="block" gutterBottom>
              연령대 빠른 선택:
            </Typography>
            <ButtonGroup size="small" aria-label="연령대 빠른 선택">
              <Button onClick={() => handleQuickBirthDate(10)}>10세</Button>
              <Button onClick={() => handleQuickBirthDate(20)}>20세</Button>
              <Button onClick={() => handleQuickBirthDate(30)}>30세</Button>
              <Button onClick={() => handleQuickBirthDate(40)}>40세</Button>
              <Button onClick={() => handleQuickBirthDate(50)}>50세</Button>
              <Button onClick={() => handleQuickBirthDate(60)}>60세</Button>
              <Button onClick={() => handleQuickBirthDate(70)}>70세</Button>
            </ButtonGroup>
          </Box>
          <FormControl fullWidth margin="normal" required>
            <InputLabel id="gender-label">성별</InputLabel>
            <Select
              labelId="gender-label"
              id="gender"
              name="gender"
              value={patientData.gender}
              onChange={handleSelectChange}
              label="성별"
            >
              <MenuItem value="MALE">남자</MenuItem>
              <MenuItem value="FEMALE">여자</MenuItem>
            </Select>
          </FormControl>
          <TextField
            margin="normal"
            required
            fullWidth
            id="mobile"
            label="전화번호"
            name="mobile"
            value={patientData.mobile}
            onChange={handleInputChange}
            placeholder="예: 010-1234-5678"
            helperText="000-0000-0000 형식으로 입력하세요"
            inputProps={{ maxLength: 13 }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>취소</Button>
        <Button onClick={onSubmit} variant="contained" color="primary">
          {submitText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PatientModal;
